import { useCallback } from 'react'
import { useVoiceRoom } from './useVoiceRoom'

export function useVoiceChat({ conversationId, onTranscript }) {
  const voice = useVoiceRoom({ conversationId, onTranscript })
  const toggle = useCallback(() => {
    if (voice.active || voice.status === 'connecting') void voice.stop()
    else void voice.start()
  }, [voice])
  return { ...voice, toggle }
}
